export const followMenu = () => {
    const header = document.querySelector('.header');

    if (document.querySelector(".home")) {
        const onScroll = () => {
            const scrollY = window.scrollY;

            if (scrollY > 10) {
                header.classList.add('header--follow');
            } else {
                header.classList.remove('header--follow');
            }
        };


        window.addEventListener('scroll', onScroll);
    }
    else {
        header.classList.add('header--follow');
    }

};